import moment from 'moment';

export const getCurrentDate = () => {
  return moment().format('MM/DD/YYYY');
};
